import { getBackendPeriodShapeFromRangePickerValue } from '@/components/form/date_range_picker/utils/getPeriodFromValue';
import dayjs from 'dayjs';
import type { Filter } from '../constants';

const getTimeRange = (from: Date | undefined, to: Date | undefined): [string, string] => {
  const now = dayjs();
  const fromDateString = from?.toISOString() ?? now.toISOString();
  const toDateString = dayjs(to).isSame(now, 'day') ? now.toISOString() : (to?.toISOString() ?? now.toISOString());

  return [fromDateString, toDateString];
};

export const getTimeRanges = (period: NonNullable<Filter['period']>, previous?: Filter['previous']) => {
  const { from, to } = getBackendPeriodShapeFromRangePickerValue(period);

  if (!(from && to)) return {};

  const currentTimeRange = getTimeRange(from, to);

  if (previous) {
    const previousTimeRanges = Array.from({ length: previous }, (_, index) => {
      const { from: prevFrom, to: prevTo } = getBackendPeriodShapeFromRangePickerValue({
        ...period,
        timeWindowShift: (period.timeWindowShift ?? 0) - (index + 1),
      });
      return getTimeRange(prevFrom, prevTo);
    });
    return { timeRanges: [currentTimeRange, ...previousTimeRanges] };
  }
  return { timeRanges: [currentTimeRange] };
};
